import ItodoImage from "../../../elements/itodo-img";
import { NavLink } from "react-router-dom";
import SectionTestimonials2 from "./section-testimonials2";

export function SectionWhyChooseUs2Inner() {
  return (
    <div className="row">
      <div className="col-lg-6 col-md-12">
        <div className="sx-about-bx4-media">
          <div className="sx-ab4-img-outer">
            <div className="sx-ab4-media"><ItodoImage src="https://images.unsplash.com/photo-1573164574230-db1d5e960238?auto=format&fit=crop&w=900&h=1400&q=80" alt="security personnel in active field coordination" /></div>
          </div>
        </div>
      </div>
      <div className="col-lg-6 col-md-12">
        <div className="sx-about-bx4-content">
          <h2 className="sx-title">Why Choose Neuron Consultancy Kenya?</h2>
          <p>Our operations model prioritizes quality over volume, real-time oversight, and dependable delivery under pressure.</p>
          <ul className="sx-arrow-circle-checked">
            <li>Former government-trained operators.</li>
            <li>Transparent workflows with clear escalation paths.</li>
            <li>Community-aware execution for field stability.</li>
          </ul>
          <NavLink to="/why-choose-us" className="site-button sx-btn-primary icon sx-btn-lg"><i className="fa fa-long-arrow-right" />View All</NavLink>
        </div>
      </div>
    </div>
  );
}

function SectionWhyChooseUs2() {
  return (
    <div className="section-full p-t110 p-b80 sx-bg-light sx-about-bx4-outer">
      <div className="container">
        <div className="section-content">
          <div className="sx-about-bx4-content-wrap p-b70"><SectionWhyChooseUs2Inner /></div>
          <SectionTestimonials2 />
        </div>
      </div>
    </div>
  );
}

export default SectionWhyChooseUs2;
